import { create } from "zustand";
export const useStatsStore = create((set) => ({
  yearData: null,
  overallData: null,
  setYearData: (yearData) => set({ yearData }),
  setOverallData: (overallData) => set({ overallData }),
}));
